<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >add cash account</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field v-model="bank" id="bank" :rules="[required]" label="bank" variant="underlined" class="form_field"></v-text-field>
              <v-text-field v-model="account_name" id="account_name" :rules="[required]" label="account name" variant="underlined" class="form_field"></v-text-field>
              <v-text-field v-model="account_type" id="account_type" :rules="[required]" label="account type" variant="underlined" class="form_field"></v-text-field>
              <v-text-field v-model="balance" id="balance" :rules="[required, numeric]" label="balance" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
              <v-text-field v-model="interest_rate" id="interest_rate" :rules="[required, numeric]" label="interest rate" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      bank: '',
      account_name: '',
      account_type: '',
      balance: '',
      interest_rate: '',
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]), 
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        
        await axios.request({
          url: "/cashaccounts/",
          method: "POST",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            bank: this.bank,
            account_name: this.account_name,
            account_type: this.account_type,
            balance: this.balance,
            interest_rate: this.interest_rate
          }
        });
          this.resetDataValues(); // clear form field values
          this.$parent.getCashAccounts(); // update list on local view
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to create cash account' });
      }
    },
    resetDataValues(){
      this.bank = "";
      this.account_name = "";
      this.account_type = "";
      this.balance = "";
      this.interest_rate = "";
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    numeric (v) {
        return !isNaN(v) || 'must be a number'
    },
  } 
}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>